import React, { useState } from 'react';
import { gallery, galleryCategories, testimonials } from '../data/mock';
import { X, Star, Filter, ChevronDown, ChevronUp } from 'lucide-react';
import SEO from '../components/SEO';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');
  const [filtersOpen, setFiltersOpen] = useState(false);

  const filteredGallery = filter === 'all' 
    ? gallery 
    : gallery.filter(item => item.categories.includes(filter));

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  // Trouver le label du filtre actif
  const activeFilterLabel = galleryCategories.find(cat => cat.value === filter)?.label || 'Tous';

  return (
    <div className="page-gallery">
      <SEO 
        title="Réalisations | Travaux d'élagage et abattage à Québec | PaysFor"
        description="Galerie photo de nos travaux d'abattage d'arbres et d'élagage à Québec. Découvrez nos réalisations en services arboricoles dans la Capitale-Nationale."
        keywords="photos élagage Québec, réalisations abattage arbres, travaux arboricoles Capitale-Nationale, portfolio élagueur Québec"
        canonical="/realisations"
      />
      {/* Hero */}
      <section className="gallery-hero">
        <div className="container">
          <h1 className="display-medium">Nos réalisations</h1>
          <p className="body-large">
            Découvrez quelques exemples de nos travaux arboricoles, paysagers et forestiers
          </p>
        </div>
      </section>

      {/* Filter */}
      <section className="gallery-filter">
        <div className="container">
          {/* Bouton mobile pour ouvrir/fermer les filtres */}
          <button 
            className="filter-toggle-mobile"
            onClick={() => setFiltersOpen(!filtersOpen)}
          >
            <Filter size={18} />
            <span>Filtres : {activeFilterLabel}</span>
            {filtersOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </button>

          {/* Conteneur des filtres - visible sur desktop, rétractable sur mobile */}
          <div className={`filter-buttons ${filtersOpen ? 'open' : ''}`}>
            {galleryCategories.map((cat) => (
              <button
                key={cat.value}
                className={`filter-btn ${filter === cat.value ? 'active' : ''}`}
                onClick={() => {
                  setFilter(cat.value);
                  setFiltersOpen(false); // Fermer les filtres après sélection sur mobile
                }}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid-section">
        <div className="container">
          <div className="gallery-grid">
            {filteredGallery.map((item) => (
              <div 
                key={item.id} 
                className="gallery-item"
                onClick={() => openLightbox(item)}
              >
                <img src={item.imageUrl} alt={item.title} loading="lazy" />
                <div className="gallery-overlay">
                  <h3 className="heading-3">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="heading-1 section-title">Ce que disent nos clients</h2>
          <p className="body-large section-subtitle">
            La satisfaction de nos clients est notre priorité
          </p>
          
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <Star key={index} size={20} fill="var(--brand-primary)" stroke="var(--brand-primary)" />
                  ))}
                </div>
                <p className="testimonial-comment body-medium">"{testimonial.comment}"</p>
                <p className="testimonial-author">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.imageUrl} alt={selectedImage.title} />
            <h3 className="heading-2">{selectedImage.title}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
